// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-7acec5bd] .el-tree-node__content {\n  height: 34px;\n}\n[data-v-7acec5bd] .el-dialog {\n  margin-top: 5vh !important;\n}\n[data-v-7acec5bd] .el-card__header {\n  padding: 0 20px\n}\n[data-v-7acec5bd] .el-card__body {\n  padding: 3px 20px\n}\n", ""]);
